<template>
    <div >
        <div style="margin: 200px auto 0px; width: 400px;" >
            {{ $t('message.GoLoginPage') }}
            <router-link to="/account/login" class="login-link"  >{{ $t('message.Login') }}</router-link>
        </div>
         <v-snackbar
            v-model="showmessage"
            bottom="bottom"
            right="right"
            :timeout="6000"
            >
            <span>{{ alertMessage }}</span>
            <v-btn v-on:click="showmessage = false" flat icon dark><v-icon>close</v-icon></v-btn>
        </v-snackbar> 
    </div>
</template>

<script>



import GenericRepository from "../../services/GenericRepository.js";

export default {
    name: "AccountValidate",
    data() {
        return {
            memberId: null,
            token: "",
            alertMessage: "",
            showmessage: false
        }
    },
    methods: {
        getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split('&');
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                if (decodeURIComponent(pair[0]) == variable) {
                    return decodeURIComponent(pair[1]);
                }
            }
        },
        load() {
            let postData = {
                "memberId": this.memberId,
                "token": this.token
            }

            GenericRepository.insert('/api/validations/member', postData)
            .then(response  => { 
                this.alertMessage = response.data.message;
                this.showmessage = true;
            });
        }
    },
    created() {
        this.memberId = this.getQueryVariable("memberId");
        this.token = this.getQueryVariable("token");
        this.load();
    }
}
</script>


<style>
</style>

